import { ExternalIntegrationCard } from '../ExternalIntegrationCard/ExternalIntegrationCard'
import { ExternalIntegrationEnum, FacebookIntegration } from 'api/clients/ExternalIntegrationsClient'
import { CardButtons } from './CardButtons'
import { useModals } from 'almanac-ui/Modal'
import { MetaAdsInitialization } from 'components/IntegrationInitialization'
import MetaBrand from 'blaze-ui/icons/20/MetaBrand'
import { useIsAdsFeatureEnabled } from 'screens/PaidAds/hooks'

export const MetaAdsCard = ({
  integrations = [],
  isDisconnected = false,
}: {
  integrations?: FacebookIntegration[]
  isDisconnected?: boolean
}) => {
  const { openModal } = useModals()

  const isAdsFeatureEnabled = useIsAdsFeatureEnabled()

  if (!isAdsFeatureEnabled) {
    return null
  }

  return (
    <ExternalIntegrationCard
      title={'Meta Ads'}
      description={'Manage ads for your Facebook and Instagram accounts'}
      integrations={integrations}
      icon={<MetaBrand size={20} />}
      isDisconnected={isDisconnected}
      buttons={
        <CardButtons
          onConnect={() => openModal(MetaAdsInitialization)}
          provider={ExternalIntegrationEnum.MetaAds}
          isConnected={integrations.length > 0}
          integration={integrations[0]}
          isDisconnected={isDisconnected}
        />
      }
    />
  )
}
